import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import { FileDownloadService } from "src/app/shared/providers/file-download/file-download.service";
import { NgbDropdown } from "@ng-bootstrap/ng-bootstrap";
import { CreateOrEditUserComponent } from "../create-or-edit-user/create-or-edit-user.component";
import { BaseComponent } from "src/app/shared/base/base-component";
import { UserManagementService } from "src/app/admin/services/user-management.service";
import { CreateOrUpdateUserDto, SearchUserInputDto, SearchUserOutputDto } from "src/app/admin/models/user-management-model";
import { PagedResult } from "src/app/admin/models/common/pagination";
import { catchError, map } from "rxjs";
import { FileDto } from "src/app/shared/models/models";

@Component({
  selector: 'app-user-list',
  templateUrl: './user-list.component.html',
  styleUrls: ['./user-list.component.scss']
})
export class UserListComponent extends BaseComponent implements OnInit, OnDestroy {
  @ViewChild("inputRef", { static: true }) inputRef: ElementRef;
  @ViewChild("dropdown") dropdown: NgbDropdown;
  public filterInputFocus: boolean = false;
  public pageSize: number = 10;
  public pageNumber: number = 1;

  public searchModel: SearchUserInputDto;
  public gridView: PagedResult<SearchUserOutputDto>;

  constructor(
    private userManagementService: UserManagementService,
    private fileDownloadService: FileDownloadService,
    private cd: ChangeDetectorRef,
  ) {
    super();
  }

  ngOnInit(): void {
    this.resetSearchModel();
    this.fetch();
  }
  ngOnDestroy(): void {
    this.subscription.forEach((sb) => sb.unsubscribe());
  }

  refresh(page: number) {
    this.searchModel.pageNumber = page;
    // this.searchModel.pageSize = this.pageSize;
    this.fetch();
  }
  onPageSizechange() {
    this.searchModel.pageNumber = 1;
    this.searchModel.pageSize = this.pageSize;
    this.fetch();
  }
  filterData(event: any) {
    this.refresh(1);
    this.toggleDropdown();
  }
  toggleDropdown() {
    if (this.dropdown.isOpen()) {
      this.dropdown.close();
    } else {
      this.dropdown.open();
    }
  }

  fetch() {
    const sub = this.userManagementService
      .GetAll(this.searchModel).pipe(
        map((response: PagedResult<SearchUserOutputDto>) => {
          this.gridView = response;
        }),
        catchError((err) => {
          if (err.status === 403)
            this.showErrorMessage(err.error.error.message);
          else
            this.translate.get('ErrorCodes.RetrieveError').subscribe(msg => this.showErrorMessage(msg));

          return this.logException(err);
        })
      )
      .subscribe();
    this.subscription.push(sub);
  }
  create(): void {
    const modalRef = this.modalService.open(CreateOrEditUserComponent, {
      size: 'xs',
    });

    modalRef.result.then(
      (res) => this.refresh(1),
      () => { }
    );
  }
  update(id: number): void {
    const sub = this.userManagementService.GetByIdForUpdate(id)
      .pipe(
        map((response: CreateOrUpdateUserDto) => {
          if (response) {
            const modalRef = this.modalService.open(CreateOrEditUserComponent, {
              size: 'xs',
            });

            modalRef.componentInstance.user = response;

            modalRef.result.then(
              (res) => this.refresh(1),
              () => { }
            );
          }
        }),
        catchError((err) => {
          if (err.status === 403)
            this.translate.get(`CreateOrUpdateUser.${err.error.error.message}`).subscribe(msg => this.showErrorMessage(msg));
          else
            this.translate.get('ErrorCodes.RetrieveError').subscribe(msg => this.showErrorMessage(msg));

          return this.logException(err);
        })
      )
      .subscribe();

    this.subscription.push(sub);
  }
  activate(id: number): void {
    this.dialogService
      .confirm("يرجى تأكيد التفعيل ..", "هل تريد تفعيل هذا المستخدم؟", "تفعيل", "رجوع", "sm")
      .then(confirmed => {
        if (confirmed) {
          const sub = this.userManagementService.Activate(id)
            .subscribe(() => {
              this.translate.get('CreateOrUpdateUser.ActivatedSuccessfully').subscribe(msg => this.showSuccessMessage(msg));
              this.refresh(1);
            }, error => {
              this.submitted = false;
              if (error.status === 403)
                this.translate.get(`CreateOrUpdateUser.${error.error.error.message}`).subscribe(msg => this.showErrorMessage(msg));
              else
                this.translate.get('ErrorCodes.CreateError').subscribe(msg => this.showErrorMessage(msg));

              return this.logException(error);
            });

          this.subscription.push(sub);
        }
      })
      .catch(() =>
        console.log(
          "User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)"
        )
      );
  }
  deactivate(id: number): void {
    this.dialogService
      .confirm("يرجى تأكيد التعطيل ..", "هل تريد تعطيل هذا المستخدم؟", "تعطيل", "رجوع", "sm")
      .then(confirmed => {
        if (confirmed) {
          const sub = this.userManagementService.Dectivate(id)
            .subscribe(() => {
              this.translate.get('CreateOrUpdateUser.DeactivatedSuccessfully').subscribe(msg => this.showSuccessMessage(msg));
              this.refresh(1);
            }, error => {
              this.submitted = false;
              if (error.status === 403)
                this.translate.get(`CreateOrUpdateUser.${error.error.error.message}`).subscribe(msg => this.showErrorMessage(msg));
              else
                this.translate.get('ErrorCodes.CreateError').subscribe(msg => this.showErrorMessage(msg));

              return this.logException(error);
            });

          this.subscription.push(sub);
        }
      })
      .catch(() =>
        console.log(
          "User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)"
        )
      );
  }
  exportAsExcel() {
    this.userManagementService.ExportExcel(this.searchModel)
      .subscribe(
        (data: FileDto) => {
          if (data) this.fileDownloadService.downloadFromBytes(data);
        },
        (error) => {
          if (error.status === 403)
            this.translate.get(`Global.${error.error.error.message}`).subscribe((msg) => this.showErrorMessage(msg));
          else
            this.translate.get("ErrorCodes.RetrieveError").subscribe((msg) => this.showErrorMessage(msg));
        }
      );
  }
  exportAsPdf() {
    this.userManagementService.ExportPdf(this.searchModel)
      .subscribe(
        (data: FileDto) => {
          if (data) this.fileDownloadService.downloadFromBytes(data);
        },
        (error) => {
          if (error.status === 403)
            this.translate.get(`Global.${error.error.error.message}`).subscribe((msg) => this.showErrorMessage(msg));
          else
            this.translate.get("ErrorCodes.RetrieveError").subscribe((msg) => this.showErrorMessage(msg));
        }
      );
  }
  private resetSearchModel() {
    this.gridView = {} as PagedResult<SearchUserOutputDto>;
    this.gridView.items = [];
    this.gridView.totalCount = 0;
    this.gridView.pageNumber = this.pageNumber;
    this.gridView.pageSize = this.pageSize;

    this.searchModel = {} as SearchUserInputDto;
    this.searchModel.pageSize = this.pageSize;
    this.searchModel.pageNumber = this.pageNumber;
  }
}
